"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateId = void 0;
var _string = require("../utils/type-checks/string");
var _uuid = require("uuid");
var generateId = exports.generateId = function generateId(prefix) {
  var id = (0, _uuid.v4)();
  if ((0, _string.isStringOfLength)(prefix)) {
    id = [prefix, id].join("-");
  }
  return id;
};